export default __webpack_public_path__ + "static/media/manual_icons.c2e5c3ca.png";